import { useJSONFetcher, JSONFetcherOptions } from "@outplayed/json-fetcher";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { QueueTypeBalances } from "@ugg/shared/interfaces/champions/queue-type-balances.interface";

export function useAramData(version?: string, options: JSONFetcherOptions = {}) {
  const { getWorkingPatch } = getRiotAssetsContext();
  const patch = getWorkingPatch(version).split(".").slice(0, -1).join("_");

  const primaryUrl = `https://static.bigbrain.gg/assets/lol/queue_type_champion_changes/aram/${patch}.json`;
  const fallbackUrl = `https://static.bigbrain.gg/assets/lol/queue_type_champion_changes/aram/latest.json`;

  const primaryData = useJSONFetcher<QueueTypeBalances>(primaryUrl, options);
  const fallbackLatest = useJSONFetcher<QueueTypeBalances>(fallbackUrl, {
    ...options,
    skip: !!primaryData.data || primaryData.loading || !primaryData.error || (options.skip ?? false),
  });

  return primaryData.data ? primaryData : fallbackLatest;
}

export function useUrfData(version?: string, options: JSONFetcherOptions = {}) {
  const { getWorkingPatch } = getRiotAssetsContext();
  const patch = getWorkingPatch(version).split(".").slice(0, -1).join("_");

  const url = `https://static.bigbrain.gg/assets/lol/queue_type_champion_changes/urf/${patch}.json`;
  return useJSONFetcher<QueueTypeBalances>(url, options);
}
